module.exports = __webpack_public_path__ + "img/interaction_example.ceb91b49.png";